// /home/oh33090489/real-estate-app/frontend/src/api/propertyApi.js

import { API_BASE } from "./base";

export async function getProperties(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const path = qs ? `/api/properties?${qs}` : "/api/properties"; // ← path 선언 필수
  const url = `${API_BASE}${path}`;                              // ← 절대경로로 호출

  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) throw new Error("failed to fetch");
  const data = await res.json();
  return {
    // 🔥 서버 응답(list / items) 모두 대응
    items: data?.items ?? data?.list ?? [],
    total:
      data?.total ??
      data?.count ??
      (Array.isArray(data?.items)
        ? data.items.length
        : Array.isArray(data?.list)
          ? data.list.length
          : 0),
  };
}

export async function getPropertyById(estateNo) {
  const url = `${API_BASE}/api/properties/${estateNo}`;

  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) throw new Error("failed to fetch property");

  const data = await res.json();

  // 🔴 STEP 1 핵심 로그 (절대 지우지 말고 확인)
  console.log("[Property API RAW]", data);
  console.log("[Property API ITEM]", data?.item);

  return data;
}

// ===================== 계약상태(contract_yn) 전용 =====================
export async function updateContractYn(estateNo, contractYn, opts = {}) {
  // [MODDATE_HOLD_V1] opts.keepModDate=true 일 때만 수정일 격리 플래그를 붙임.
  //   세 번째 인자 없이 부르는 다른 화면(목록 토글 등)은 기존과 100% 동일
  const url = `${API_BASE}/api/properties/${estateNo}/contract` + (opts && opts.keepModDate ? "?keepModDate=1" : "");

  const res = await authFetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ contract_yn: contractYn }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`updateContractYn failed: ${text.slice(0,120)}`);
  }

  const data = await res.json();
  if (!data?.ok) {
    throw new Error(data?.error || "updateContractYn failed");
  }
  return data;
}


export async function saveRentItems(pid, items, memo) {
  // authFetch는 localStorage의 token을 자동으로 헤더에 추가해줌
  const r = await authFetch(`/api/properties/${pid}/rent-items`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items, memo: memo ?? "" }),
  });

  const ct = r.headers.get("content-type") || "";
  const isJson = ct.includes("application/json");
  const data = isJson ? await r.json() : await r.text();

  if (!r.ok) {
    // ✅ 수정: HTTP 상태코드도 함께 보여줌 (예: "HTTP 404: Cannot PUT /api/...")
    const errMsg = isJson
      ? (data?.error || `HTTP ${r.status}`)
      : `HTTP ${r.status}: ${String(data).slice(0, 300)}`; // ← 200자→300자로 늘림
    throw new Error(errMsg);
  }

  // ✅ 수정: JSON이 아닌 응답(보통 HTML 에러 페이지)일 때 내용 일부를 보여줌
  if (!isJson) {
    throw new Error("서버 응답이 JSON이 아닙니다. 라우트가 등록되지 않았을 수 있습니다: " + String(data).slice(0, 200));
  }

  return data;
}

export async function getPhotoStorage(){
  const r = await authFetch("/api/properties/photo-storage");
  const text = await r.text();
  try { return JSON.parse(text); } catch {
    throw new Error("photo-storage not JSON: " + text.slice(0,120));
  }
}

export async function setPhotoStorage(storage){
  return authFetch("/api/properties/photo-storage",{
    method:"PUT", headers:{ "Content-Type":"application/json" },
    headers:{ "Content-Type":"application/json" },
    body: JSON.stringify({ storage })
  }).then(r=>r.json());
}
// export async function uploadServerPhoto(propertyId, file){
//   const fd = new FormData(); fd.append("file", file);
//   return fetch(`/api/properties/${propertyId}/photos`, { method:"POST", body: fd }).then(r=>r.json());
// }

export async function uploadServerPhoto(propertyId, file){
  const fd = new FormData(); fd.append("file", file);
  const r = await fetch(`/api/properties/${propertyId}/photos`, { method:"POST", body: fd });
  if (!r.ok) throw new Error("uploadServerPhoto failed");
  return r.json();
}

// ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 

// ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 

export async function listServerPhotos(propertyId){
  return fetch(`/api/properties/${propertyId}/photos`).then(r=>r.json());
}
export async function deleteServerPhoto(propertyId, photoId){
  return fetch(`/api/properties/${propertyId}/photos/${photoId}`, { method:"DELETE" }).then(r=>r.json());
}

function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  const headers = {
    ...(options.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(url, {
    ...options,
    headers,
    credentials: "same-origin",
  });
}

// propertyApi.js 공통 헬퍼
async function getJSON(url, opts){
  const r = await fetch(url, opts);
  const ct = r.headers.get("content-type")||"";
  const text = await r.text();
  if (!r.ok || !ct.includes("application/json")) {
    throw new Error(`API ${url} invalid: ` + text.slice(0,120));
  }
  return JSON.parse(text);
}

// 사용 예
// export async function getPhotoStorage(){
//   return getJSON("/api/properties/photo-storage");
// }

// =========================================================
// 📸 스냅샷 API 함수들
// =========================================================

/**
 * [버그 수정] createFullSnapshot
 * - 수정 전: /api/snapshot/create (서버에 존재하지 않는 URL)
 * - 수정 후: /api/properties/snapshots/full (properties.js에 새로 추가된 라우트)
 * - body 필드명도 서버와 일치시킴: estateNo→propertyId, payload→snapshotData
 * - 저장 성공 시 서버가 반환하는 { ok, fileName } 을 그대로 반환
 *   → EstateEditor.jsx: .then(res => console.log("아카이빙 완료:", res.fileName))
 */
export async function createFullSnapshot(estateNo, snapshotData) {
  const r = await authFetch(`/api/properties/snapshots/full`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      propertyId: estateNo,  // 서버: const { propertyId } = req.body
      snapshotData,          // 서버: const { snapshotData } = req.body
    }),
  });

  if (!r.ok) {
    const errText = await r.text();
    throw new Error(`Snapshot failed: ${errText.slice(0, 100)}`);
  }
  return r.json(); // { ok: true, fileName: "42_1716700800000" }
}

/**
 * getSnapshotList - 변경 없음 (이미 올바른 URL)
 * GET /api/snapshot/list/:estateNo → server.js 에서 처리
 * 수정된 server.js가 { ok, items: [{ fileName, createdAt }] } 로 응답
 */
export async function getSnapshotList(estateNo) {
  const r = await authFetch(`/api/snapshot/list/${estateNo}`);
  if (!r.ok) throw new Error("스냅샷 목록 로드 실패");
  return r.json();
}

/**
 * [버그 수정] getSnapshotDetail
 * - 수정 전: /api/snapshot/detail/${estateNo}/${fileName}  ← estateNo가 불필요하게 포함
 * - 수정 후: /api/snapshot/detail/${fileName}
 *   → server.js 의 GET /api/snapshot/detail/:fileName 라우트와 일치
 *   → fileName 자체가 "42_1716700800000" 형태로 이미 매물번호 포함
 * - estateNo 파라미터는 하위 호환성을 위해 유지 (실제로는 미사용)
 */
export async function getSnapshotDetail(estateNo, fileName) {
  // estateNo는 이전 버전 호환용으로 남겨둠 (URL에서는 제거)
  const r = await authFetch(`/api/snapshot/detail/${fileName}`);
  if (!r.ok) throw new Error("스냅샷 상세 로드 실패");
  return r.json(); // { ok: true, data: { ...스냅샷데이터 } }
}